<template>
  <div class="d-flex justify-content-start align-items-start nowrap">
    <!-- INVISIBLE AVATAR -->
    <div class="avatar invisible mr-2 d-none d-md-block"></div>
    <!-- INVISIBLE AVATAR -->
    <div
      class="w-100 post-homework-section rounded-10 d-flex justify-content-start align-items-start nowrap"
    >
      <div class="w-100 d-flex justify-content-between align-items-start">
        <div class="top-block">
          <!-- HOMEWORK AVATAR -->
          <div class="avatar brand_inverse_light_bg">
            <div class="span flex-center icon-library brand_navy font-17"></div>
          </div>

          <!-- HOMEWORK INFO -->
          <template v-if="post.reference === null">
            <div class="d-flex flex-column">
              <div class="font-14 color_ash font-weight-bold">
                Assessment details not available
              </div>
              <div class="font-13-5 brand_tonic mt-2">Invalid assessment</div>

              <div class="learn-more mt-3 color_grey_dark font-13-5">
                <div v-if="account_type === 'parent'">
                  Contact school for assessment update
                </div>
                <div v-if="account_type === 'teacher'">
                  It seems this assessment has already been deleted by you.
                </div>
                <div v-if="account_type === 'student'">
                  Contact your class teacher for assessment update
                </div>
                <div v-if="account_type === 'school'">
                  Contact class teacher for assessment update
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="homework-info">
              <div
                class="title color_text font-weight-600"
                v-if="post.reference"
              >
                {{ post.reference.title }}
              </div>
              <div class="title color_ash" v-else>No assessment title</div>
              <div class="subject color_grey_dark">
                {{
                  post.reference
                    ? post.reference.subject.name
                    : "No subject selected"
                }}
              </div>

              <!-- HOMEWORK TIMING INFO -->
              <div class="time-row">
                <div
                  class="left-block font-weight-bold"
                  :class="isAssessmentOpen ? 'brand_green' : 'brand_tonic'"
                  v-if="post.reference"
                >
                  {{ post.reference.close_date | checkStatus }}
                </div>
                <div
                  class="border_grey_dark left-block font-weight-bold"
                  v-else
                >
                  N/A
                </div>

                <div class="color_text">
                  <span
                    class="date color_ash"
                    v-if="post.reference && post.reference.close_date"
                    >{{ post.reference.close_date | getDateOnly }}</span
                  >
                  <span class="date border_grey_dark" v-else
                    >No assessment date set</span
                  >
                  &nbsp;
                </div>
              </div>

              <!-- HOMEWORK STATUS INFO -->
              <template v-if="post.type == 'homework'">
                <div class="status-row color_grey_dark font-weight-bold">
                  <div class="left-block">STATUS</div>
                  <div class>DUE DATE</div>
                </div>
              </template>

              <div
                class="mb-4"
                v-if="
                  account_type === 'school' ||
                    (account_type === 'teacher' && post.isOwner)
                "
              >
                <!-- REPORT LINK -->
                <router-link
                  :to="{
                    name: route_name,
                    params: { homework_id: post.reference.id },
                  }"
                  class="school-teacher-link my-2 text-report color_ash font-weight-bold text-capitalize"
                  >View Report</router-link
                >
              </div>

              <div class="mb-4" v-if="account_type === 'parent'">
                <router-link
                  v-if="post.reference.is_closed"
                  to
                  class="parent-link my-2 text-report color_ash font-weight-bold text-capitalize"
                  :class="assessment_closed"
                  >{{ post.reference.tag }} Closed</router-link
                >

                <router-link
                  v-else-if="post.reference.is_taken"
                  to
                  class="parent-link my-2 text-report color_ash font-weight-bold text-capitalize"
                  :class="assessment_closed"
                  >{{ post.reference.tag }} Taken</router-link
                >

                <router-link
                  v-else
                  to
                  @click.native="toggleSwitchModal"
                  class="parent-link my-2 text-report color_ash font-weight-bold text-capitalize"
                  >Attempt {{ post.reference.tag }}</router-link
                >
              </div>

              <div class="mb-4" v-if="account_type === 'student'">
                <router-link
                  v-if="post.reference.is_closed"
                  to
                  class="parent-link my-2 text-report color_ash font-weight-bold text-capitalize"
                  :class="assessment_closed"
                  >{{ post.reference.tag }} Closed</router-link
                >

                <router-link
                  v-else-if="post.reference.is_taken"
                  to
                  class="parent-link my-2 text-report color_ash font-weight-bold text-capitalize"
                  :class="assessment_closed"
                  >{{ post.reference.tag }} Taken</router-link
                >

                <!-- STUDENT ASSESSMENT TYPE -->
                <template v-else>
                  <div
                    v-if="post.reference.tag === 'homework'"
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <!-- IF SUBSCRIBED -->
                    <template v-if="subscription_status === true">
                      <button
                        @click="toggleHomeworkModal"
                        class="parent-link my-2 text-report color_ash font-weight-bold rounded-20"
                        :disabled="!hasStarted"
                      >
                        Start Homework
                      </button>
                    </template>
                    <!-- NO SUBSCRIPTION -->
                    <template v-else>
                      <div
                        class="btn-lock my-1 text-report brand_tonic font-weight-bold my-1"
                      >
                        <div class="icon-lock-fill mr-1"></div>
                        <div class="lock-text ml-1">Access Locked</div>
                      </div>
                    </template>
                  </div>

                  <div
                    v-else-if="post.reference.tag === 'exam'"
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <!-- IF SUBSCRIBED -->
                    <template v-if="subscription_status === true">
                      <template v-if="post.reference.is_proctor">
                        <!-- @click="toggleExamModal(post.reference.id)" -->
                        <button
                          @click="toInstructionPage"
                          aria-label="Exam not started"
                          class="parent-link my-2 text-report color_ash font-weight-bold rounded-20"
                        >
                          Start Exam
                        </button>

                        <!-- <router-link
                          to
                          @click.native="toggleExamModal(post.reference.id)"
                          class="parent-link my-2 text-report color_ash font-weight-bold"
                          >Start Exam</router-link
                        > -->
                      </template>
                      <template v-else>
                        <!-- <router-link
                          to
                          @click.native="toggleHomeworkModal"
                          class="parent-link my-2 text-report color_ash font-weight-bold"
                          >Start Exam</router-link
                        > -->
                        <!-- @click="toggleHomeworkModal" -->
                        <button
                          @click="toInstructionPage"
                          class="parent-link my-2 text-report color_ash font-weight-bold rounded-20"
                        >
                          Start Exam
                        </button>
                      </template>
                    </template>

                    <template v-else>
                      <div
                        class="btn-lock my-1 text-report brand_tonic font-weight-bold my-1"
                      >
                        <div class="icon-lock-fill mr-1"></div>
                        <div class="lock-text ml-1">Access Locked</div>
                      </div>
                    </template>
                  </div>

                  <div
                    v-else-if="post.reference.tag === 'quiz'"
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <!-- IF SUBSCRIBED -->
                    <template v-if="subscription_status === true">
                      <router-link
                        to
                        @click.native="toggleHomeworkModal"
                        class="parent-link my-2 text-report color_ash font-weight-bold"
                        >Start Quiz</router-link
                      >
                    </template>
                    <!-- NO SUBSCRIPTION -->
                    <template v-else>
                      <div
                        class="btn-lock my-1 text-report brand_tonic font-weight-bold my-1"
                      >
                        <div class="icon-lock-fill mr-1"></div>
                        <div class="lock-text ml-1">Access Locked</div>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>

        <!-- HOMEWORK OPTIONS -->
        <div class="position-relative" v-if="false">
          <div
            class="avatar border pointer homework-options"
            v-on-clickaway="dropOption"
            @click="toggleHomeworkOption"
            v-if="account_type === 'teacher'"
          >
            <span
              class="icon-options font-20 flex-center border_grey_dark"
            ></span>
          </div>
          <!-- DROPDOWN MENU -->
          <div
            class="dropdown-btn-menu placement-bottom"
            v-if="homework_option"
          >
            <ul class="list-unstyled">
              <!-- <li>
                <router-link to>View Details</router-link>
              </li>-->
              <li>
                <router-link to>Edit Homework</router-link>
              </li>
              <li>
                <router-link to>Extend due date</router-link>
              </li>
              <li>
                <router-link to>Refresh Homework</router-link>
              </li>
              <!-- <li>
                <router-link to>Delete Homework</router-link>
              </li>-->
            </ul>
          </div>
        </div>
        <!-- HOMEWORK OPTIONS -->
      </div>
    </div>

    <!-- MODAL -->
    <StartHomeworkModal
      v-if="homework_modal"
      :tag="post.reference.tag"
      :homework_data="post.reference"
      @toggleProctor="toggleExamModal($event)"
      @closeTriggered="toggleHomeworkModal"
    ></StartHomeworkModal>

    <SwitchAccountModal
      v-if="switch_modal"
      @closeTriggered="toggleSwitchModal"
    />

    <StartExamModal
      v-if="exam_modal"
      :tag="post.reference.tag"
      :exam_id="exam_id"
      @closeTriggered="toggleExamModal"
    />
    <!-- MODAL -->
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import { getReadableDate } from "@/scripts/utilities";

export default {
  name: "PostHomeworkBlock",

  components: {
    StartHomeworkModal: () =>
      import(
        /* webpackChunkName: "StartHomeworkModal" */
        "@/components/modalComps/parentModals/StartHomeworkModal"
      ),
    StartExamModal: () =>
      import(
        /* webpackChunkName: "StartExamModal" */
        "@/components/modalComps/parentModals/StartExamModal"
      ),
    SwitchAccountModal: () =>
      import(
        /* webpackChunkName: "SwitchAccountModal" */
        "@/components/modalComps/parentModals/SwitchAccountModal"
      ),
  },

  props: {
    post: Object,
    subscription_status: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [clickaway],

  data() {
    return {
      account_type: null,
      homework_modal: false,
      exam_modal: false,
      switch_modal: false,

      exam_id: "",
      route_name: "",
      homework_option: false,
      assessment_closed:
        "disabled opacify font-weight-400 border_grey_dark border",
    };
  },

  computed: {
    isAssessmentOpen() {
      let current_date = new Date();
      let close_date = new Date(this.post.reference.close_date);
      if (current_date > close_date) return false;
      else return true;
    },

    hasStarted() {
      return true;
      // let current_date = new Date();
      // let open_date = new Date(this.post.reference.open_date);
      // return open_date <= current_date;
    },
  },

  filters: {
    checkStatus(val) {
      let current_date = new Date();
      let close_date = new Date(val);
      if (current_date > close_date) return "Close";
      else return "Open";
    },

    formatOpenDate(val) {
      const date = new Date(val);
      console.log(date);
      return date.getMonth();
    },

    getDateOnly(val) {
      let date = val.split(" ");
      let split_date = date[0]
        .split("-")
        .reverse()
        .join("-");
      return getReadableDate(split_date);
    },
  },

  mounted() {
    this.getAccountType();
  },

  methods: {
    toInstructionPage() {
      let in_dev = process.env.NODE_ENV === "development";
      location.href = in_dev
        ? `http://localhost:8096/test/start-exam/${this.post.reference.id}`
        : `https://app.gradely.ng/test/start-exam/${this.post.reference.id}`;
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
      if (this.account_type === "school") this.route_name = "HomeworkReview";
      else if (this.account_type === "teacher")
        this.route_name = "HomeworkReview_TP";
    },

    toggleSwitchModal() {
      this.switch_modal = !this.switch_modal;
    },

    toggleHomeworkModal() {
      this.homework_modal = !this.homework_modal;
    },

    toggleExamModal(event) {
      this.exam_id = event;
      this.exam_modal = !this.exam_modal;
    },

    toggleHomeworkOption() {
      this.homework_option = !this.homework_option;
    },

    dropOption() {
      this.homework_option = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.post-homework-section {
  border: 1px solid #dbf5f8;
  height: auto;
  box-sizing: border-box;
  padding: 10px 10px 14px;
  margin-left: 4px;
  margin-top: 10px;

  @include breakpoint_max(sm) {
    margin-left: 9px;
  }

  .top-block {
    @include flex_row_start_nowrap;
    align-items: flex-start;
    position: relative;

    .avatar {
      margin-right: 10px;

      @include breakpoint_max(sm) {
        @include equal_min_edge(32);
      }
    }

    .title {
      font-size: 13.5px;
      line-height: 19px;
      margin-bottom: 3px;
      text-transform: capitalize;

      @include breakpoint_max(sm) {
        font-weight: 600 !important;
        color: $color_text !important;
        font-size: 12px;
      }
    }

    .subject {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 14px;

      @include breakpoint_max(sm) {
        font-size: 11px;
      }
    }

    .time-row {
      @include flex_row_start_nowrap;
      font-weight: bold;
      font-size: 13px;
      line-height: 140%;
      margin-bottom: 4px;

      @include breakpoint_max(sm) {
        font-size: 11.5px;
      }
    }

    .status-row {
      @include flex_row_start_nowrap;
      font-size: 9px;
      line-height: 177.06%;
      margin-bottom: 12px;
    }

    .text-report {
      font-size: 12px;

      @include breakpoint_max(sm) {
        font-size: 11px;
      }

      @include breakpoint_max(xs) {
        font-size: 10.5px;
      }
    }

    .left-block {
      width: 60px;
    }

    a {
      transition: all 0.3s ease-in-out;
      border-radius: 20px;
    }

    .student-link,
    .parent-link,
    .school-teacher-link,
    .btn-lock {
      @include flex_row_center_nowrap;
      padding: 10px 20px;
      position: relative;
      top: 10px;
      font-size: 13px;
      width: max-content;

      .icon-lock-fill {
        font-size: 12px;
      }

      @include breakpoint_max(sm) {
        padding: 8px 16px;
        font-size: 11px;
      }
    }

    .student-link {
      background: $brand_accent_light;
      border: 1px solid $brand_accent;
      &:hover {
        color: $brand_inverse !important;
        background: $brand_inverse_light;
        border: 1px solid $brand_inverse;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
      }
    }

    .parent-link {
      background: $brand_accent_light;
      border: 1px solid $brand_accent;
      &:hover {
        color: $brand_inverse !important;
        background: $brand_inverse_light;
        border: 1px solid $brand_inverse;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
      }
      &:disabled {
        border: 0px solid $brand_inverse;
        cursor: not-allowed !important;
      }
    }

    .school-teacher-link {
      font-size: 12px;
      background: $brand_accent_light;
      border: 1px solid $brand_accent;

      @include breakpoint_max(sm) {
        font-size: 11px;
      }
      &:hover {
        color: $brand_inverse !important;
        background: $brand_inverse_light;
        border: 1px solid $brand_inverse;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .dropdown-btn-menu {
    width: 180px;

    a {
      font-size: 12px;
      color: $color_grey_dark;
      padding: 9px 5px;
    }
  }

  .opacify {
    background: $border_grey_light !important;
    border: 1px solid $border_grey !important;
    opacity: 0.7;
  }

  .btn-lock {
    border: 1px solid $brand_red;
    border-radius: 30px;
    cursor: not-allowed !important;
    background: $brand_red_light;

    &:hover {
      border: 1px solid $brand_red;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>
